export { default as SimpleSearchForm } from "./SimpleSearchForm";
